import { render, staticRenderFns } from "./RequestVideoModal.vue?vue&type=template&id=2e5a8287"
import script from "./RequestVideoModal.vue?vue&type=script&lang=js"
export * from "./RequestVideoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports